// extracted by mini-css-extract-plugin
export default {"cellWrapper":"FileNameCell_cellWrapper__yrNQR","cellText":"FileNameCell_cellText__EpM8e"};